import { useCurrentUser } from '@hotjar/user';
import { useUserExperiment } from '@hotjar/webapp/hooks/useExperiment';
import { Store } from '../../../store/list/types';

const EXPERIMENT_KEY = 'recs_recommended_widgets_v3';

interface RecommendedWidgetsProps {
  isOverviewExperimentEnabled: boolean;
  inExperiment: boolean;
}

export const useRecommendedWidgets = (store: Store): RecommendedWidgetsProps => {
  const { isTrackingCodePromptVisible, site, setIsOverviewExperimentEnabled } = store.getState();
  const { data: user } = useCurrentUser();
  const canSeeExperiment =
    (site?.effectivePlan === 'business' || site?.effectivePlan === 'scale') &&
    !isTrackingCodePromptVisible();

  const { inVariant1, inExperiment } = useUserExperiment(EXPERIMENT_KEY, user, canSeeExperiment);

  setIsOverviewExperimentEnabled(inVariant1);

  return {
    isOverviewExperimentEnabled: inVariant1,
    inExperiment: !!inExperiment,
  };
};
